import { useTranslation } from "react-i18next";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { FadeUp, Overline } from "@/components/FadeUp";
import EnquiryForm from "@/components/EnquiryForm";
import { CONTACT } from "@/lib/api";

export default function Contact() {
  const { t } = useTranslation();
  return (
    <div data-testid="contact-page">
      <section className="py-20 md:py-28 border-b border-slate-200 bg-[#F4F7F9]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Overline>{t("contactPage.overline")}</Overline>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-[#0A2540] max-w-2xl">
            {t("contactPage.title")}
          </h1>
          <p className="mt-5 text-base md:text-lg text-slate-600 max-w-xl leading-relaxed">
            {t("contactPage.subtitle")}
          </p>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-3 gap-12">
          <FadeUp className="lg:col-span-2">
            <div className="border border-slate-200 bg-white p-8 md:p-12">
              <EnquiryForm type="kontakt" />
            </div>
          </FadeUp>
          <FadeUp delay={0.15}>
            <div className="border border-slate-200 bg-[#F4F7F9] p-8 space-y-6" data-testid="contact-info-card">
              <div>
                <p className="text-sm tracking-[0.2em] uppercase font-semibold text-slate-500">{t("contactPage.directTitle")}</p>
                <a href={CONTACT.phoneHref} data-testid="contact-phone-btn"
                   className="mt-3 flex items-center gap-3 text-lg font-bold text-[#0A2540] hover:text-[#0052CC]">
                  <Phone className="w-5 h-5 text-[#0052CC]" /> {CONTACT.phone}
                </a>
                <a href={`mailto:${CONTACT.email}`} data-testid="contact-email-link"
                   className="mt-3 flex items-center gap-3 text-slate-700 hover:text-[#0052CC]">
                  <Mail className="w-5 h-5 text-[#0052CC]" /> {CONTACT.email}
                </a>
              </div>
              <div className="border-t border-slate-200 pt-6">
                <p className="text-sm tracking-[0.2em] uppercase font-semibold text-slate-500">{t("contactPage.showroomTitle")}</p>
                <p className="mt-3 flex items-start gap-3 text-slate-700">
                  <MapPin className="w-5 h-5 text-[#0052CC] mt-0.5 shrink-0" /> {CONTACT.address}
                </p>
                <p className="mt-3 flex items-start gap-3 text-slate-700">
                  <Clock className="w-5 h-5 text-[#0052CC] mt-0.5 shrink-0" /> {t("contactPage.hours")}
                </p>
              </div>
            </div>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}
